export default {
  reportTypes: state => state.reportTypes,
  selectedReportType: state => state.selectedReportType,
  operators: state => state.operators
}
